<template>
  <div>
    <!-- <b-loading :active.sync="isLoadingPage"></b-loading> -->
    <transition name="slide-fade">
      <div class="loading-integreat" v-if="isLoadingPage" >
          <div class="initial-load-animation" >
          <div class="linkedin-image"></div>
            <div class="loading-bar">
              <div class="blue-bar"></div>
            </div>
          </div>
      </div>
    </transition>
      <p class="title is-size-4-tablet is-size-5-mobile has-text-weight-bold"
        >Smart report ({{staffLists.length}} {{(staffLists.length > 1)?'department':'departments'}})</p>
    <div class="level is-margin-bottom-2 is-hidden-mobile">
      <div class="level-left">
        
      </div>
      <div class="level-right">
      </div>
    </div>
    <b-tabs v-model="activeTab" size="is-large " class="tab-thai"
    :class="{'tab-exclusive':getRule=='exclusiveboard'?true:false,'tab-board':getRule=='board'?true:false}"
    >
      <b-tab-item label="หน่วยงานในสังกัด" class="mg-less tab-thai">
        <div class="columns is-margin-x-not head-table is-hidden-mobile">
          <div class="column is-offset-1 is-2 has-text-centered" @click="sortBy('name')">
            <p
              class="is-size-7 has-text-weight-semibold cr-pointer"
              :class="{'has-text-secondary':currentSort === 'name'}"
            >
              Department
              <span
                class="arrow"
                :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                v-show="currentSort == 'name'"
              ></span>
            </p>
          </div>
          <div class="column is-5 has-text-centered" @click="sortBy('mobilePhone')">
            <p
              class="is-size-7 has-text-weight-semibold cr-pointer"
              :class="{'has-text-secondary':currentSort === 'mobilePhone'}"
            >
              Event Overview
              <span
                class="arrow"
                :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                v-show="currentSort == 'mobilePhone'"
              ></span>
            </p>
          </div>
          <div class="column is-2 has-text-centered" @click="sortBy('email')">
            <p
              class="is-size-7 has-text-weight-semibold cr-pointer"
              :class="{'has-text-secondary':currentSort === 'email'}"
            >
              Performance Support
              <span
                class="arrow"
                :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                v-show="currentSort == 'email'"
              ></span>
            </p>
          </div>
          <div class="column is-2 has-text-centered" @click="sortBy('countStartUp')">
            <p
              class="is-size-7 has-text-weight-semibold cr-pointer"
              :class="{'has-text-secondary':currentSort === 'countStartUp'}"
            >
              Operation overview
              <span
                class="arrow"
                :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                v-show="currentSort == 'countStartUp'"
              ></span>
            </p>
          </div>
        </div>
        <div
          class="columns detail-table is-margin-x-not cr-pointer is-vcentered"
          :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}"
          v-for="(data,index) in staffLists"
          :key="index"
          @click="goToAdmin(data.departmentId,'in')"
        >
          <div class="column is-3" data-label="name">
            <div
              v-if="widthMax > 768"
              class="is-align-center is-justify-center is-flex-large is-flex-row is-hidden-mobile"
            >
              <div class="column is-4 is-2-fullhd has-text-centered-tablet has-text-right is-paddingless">
                <figure class="image is-marginless">
                  <img  v-if="data.logo"
                  @error="$event.target.src = 'https://bulma.io/images/placeholders/64x64.png'"
                   :src="imgUrlSC+data.logo">
                  <img
                    class="is-rounded"
                    v-else
                    src="https://bulma.io/images/placeholders/64x64.png"
                    alt="Placeholder image"
                  >
                </figure>
              </div>
              <div class="column is-8 has-text-centered">
                <p class="is-size-7 th">{{data.departmentName}}</p>
                <!-- <p class="is-size-7 th">University science Park</p> -->
              </div>
            </div>
            <div
              v-if="widthMax < 768"
              class="is-align-center is-justify-center is-flex is-flex-column is-hidden-tablet"
            >
              <div class="column is-5 has-text-centered pd-col-fixed">
                <figure class="image box-logo-l">
                 <img  v-if="data.logo" 
                 @error="$event.target.src = 'https://bulma.io/images/placeholders/64x64.png'"
                  :src="imgUrlSC+data.logo">
                  <img
                    class="is-rounded"
                    v-else
                    src="https://bulma.io/images/placeholders/64x64.png"
                    alt="Placeholder image"
                  >
                </figure>
              </div>
              <div class="column is-1 has-text-centered pd-col-fixed">
                <p class="is-size-7 th">{{data.departmentName}}</p>
                <!-- <p class="is-size-7 th">University science Park</p> -->
              </div>
            </div>
          </div>
          <div class="column is-1 has-text-centered" data-label="mobilePhone">
            <p class="has-text-centered is-size-2 has-text-weight-bold done-color" >{{data.allCompanies}}</p>
    		<p class="has-text-centered is-size-7 has-text-weight-semibold">All Projects</p>
          </div>
          <div class="column is-2" data-label="email">
            <p class="is-size-7 has-text-weight-normal is-flex is-align-center " :class="{'is-justify-center':widthMax < 768}">
            	<b-icon pack="fas" icon="circle" class="color-inprocess"></b-icon> In process: {{data.inprocess}} Projects
        		</p>
        		<p class="is-size-7 has-text-weight-normal is-flex is-align-center" :class="{'is-justify-center':widthMax < 768}">
                	<b-icon pack="fas" icon="circle" class="has-text-info"></b-icon> Acheived: {{data.acheived}} Projects
        		</p>
              </div>
              <div class="column is-2" data-label="email ">
                <p class="is-size-7 has-text-weight-normal is-flex is-align-center" :class="{'is-justify-center':widthMax < 768}">
                	<b-icon pack="fas" icon="circle" class="color-succeed"></b-icon> Succeed: {{data.succeed}} Projects
        		</p>
        		<p class="is-size-7 has-text-weight-normal is-flex is-align-center" :class="{'is-justify-center':widthMax < 768}">
                	<b-icon pack="fas" icon="circle" class="color-deactive"></b-icon> Deactive: {{data.deactive}} Projects
        		</p>
          </div>
          <div class="column is-2 has-text-centered" data-label="updatedAt">
            <p class="has-text-centered is-size-2 has-text-weight-bold done-color">{{data.activities}}</p>
    		<p class="has-text-centered has-text-weight-semibold">Activities</p>
          </div>
          <div class="column is-2 has-text-centered" data-label="updatedAt">
            <p class="has-text-centered is-size-6 th done-color">Task Done 
              <span v-if="data.task == 0">0 %</span>  
              <span v-else>{{getPercentask(data.task,data.done) | floatNumber}} %</span>
            </p>
    		<!-- <p class="has-text-centered is-size-6 th overdue-color">Task Overdue
              <span v-if="data.overdue == 0">0 %</span>  
              <span v-else >{{getPercentask(data.task,data.overdue) | floatNumber}} %</span></p> -->
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="หน่วยงานนอกสังกัด" class="mg-less tab-thai">
        <div class="columns is-margin-x-not head-table is-hidden-mobile" >
      <div class="column is-offset-1 is-2 has-text-centered" @click="sortBy('name')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{'has-text-secondary':currentSort === 'name'}"
        >
          Name Lastname
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'name'"
          ></span>
        </p>
      </div>
      <div class="column is-5 has-text-centered" @click="sortBy('mobilePhone')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{'has-text-secondary':currentSort === 'mobilePhone'}"
        >
          Event Overview
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'mobilePhone'"
          ></span>
        </p>
      </div>
      <div class="column is-2 has-text-centered" @click="sortBy('email')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{'has-text-secondary':currentSort === 'email'}"
        >
          Performance Support
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'email'"
          ></span>
        </p>
      </div>
      <div class="column is-2 has-text-centered" @click="sortBy('countStartUp')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{'has-text-secondary':currentSort === 'countStartUp'}"
        >
          Operation overview
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'countStartUp'"
          ></span>
        </p>
      </div>
    </div>
    <div v-if="adminData == 0" class="is-detail-list detail-table mg-y-15">
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">***</p>
      <p class="has-text-drak is-size-6 th is-padding-x has-text-centered">ขณะนี้ยังไม่มีเจ้าหน้าที่</p>
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">***</p>
    </div>
    <div
      class="columns detail-table is-margin-x-not is-vcentered cr-pointer"
      :class="{'hover-border':getRule=='exclusiveboard'?true:false,'hover-border-board':getRule=='board'?true:false}"
      v-for="(data,index) in adminData"
      :key="index" @click="goToCompany(data.adminId)"
      v-else
    >
        <div class="column is-3" data-label="name">
          <div
            v-if="widthMax > 768"
            class="is-align-center is-justify-center is-flex-large is-flex-row is-hidden-mobile"
          >
            <div class="column is-4 is-2-fullhd has-text-centered-tablet has-text-right">
              <figure class="image box-circle-m is-marginless">
                <img class="is-rounded"
                @error="$event.target.src = 'https://bulma.io/images/placeholders/64x64.png'"
                 v-if="data.profile" :src="imgUrl+data.profile">
                <img
                  class="is-rounded"
                  v-else
                  src="https://bulma.io/images/placeholders/64x64.png"
                  alt="Placeholder image"
                >
              </figure>
            </div>
            <div class="column is-8 has-text-centered">
              <p class="is-size-7 th">{{data.name}} {{data.surname}}</p>
            </div>
          </div>
          <div
            v-if="widthMax < 768"
            class="is-align-center is-justify-center is-flex is-flex-column is-hidden-tablet"
          >
            <div class="column is-5 has-text-centered pd-col-fixed">
              <figure class="image box-circle-s">
                <img class="is-rounded"
                @error="$event.target.src = 'https://bulma.io/images/placeholders/64x64.png'"
                 v-if="data.profile" :src="imgUrl+data.profile">
                <img
                  class="is-rounded"
                  v-else
                  src="https://bulma.io/images/placeholders/64x64.png"
                  alt="Placeholder image"
                >
              </figure>
            </div>
            <div class="column is-1 has-text-centered pd-col-fixed">
              <p class="is-size-7 th">{{data.name}} {{data.surname}}</p>
            </div>
          </div>
        </div>
        <div class="column is-1 has-text-centered" data-label="mobilePhone">
          <p class="has-text-centered is-size-2 has-text-weight-bold done-color">{{data.allCompanies}}</p>
      <p class="has-text-centered is-size-7 has-text-weight-semibold">All Projects</p>
        </div>
        <div class="column is-2" data-label="email">
          <p class="is-size-7 has-text-weight-normal  is-flex is-align-center">
            <b-icon pack="fas" icon="circle" class="color-inprocess"></b-icon> In process: {{data.status.inprocess}} Projects
          </p>
          <p class="is-size-7 has-text-weight-normal is-flex is-align-center">
                <b-icon pack="fas" icon="circle" class="has-text-info"></b-icon> Acheived: {{data.status.acheived}} Projects
          </p>
        </div>
        <div class="column is-2" data-label="email">
          <p class="is-size-7 has-text-weight-normal is-flex is-align-center">
            <b-icon pack="fas" icon="circle" class="color-succeed"></b-icon> Succeed: {{data.status.succeed}} Projects
          </p>
          <p class="is-size-7 has-text-weight-normal is-flex is-align-center">
            <b-icon pack="fas" icon="circle" class="color-deactive"></b-icon> Deactive: {{data.status.deactive}} Projects
          </p>
        </div>
        <div class="column is-2 has-text-centered" data-label="updatedAt">
          <p class="has-text-centered is-size-2 has-text-weight-bold done-color">{{data.activities}}</p>
          <p class="has-text-centered has-text-weight-semibold">Activities</p>
        </div>
        <div class="column is-2 has-text-centered" data-label="updatedAt">
          <p class="has-text-centered is-size-6 th done-color">Task Done 
            <span v-if="data.task.taskDone == 0">0 %</span> 
            <span  v-else>{{getPercentask(data.task.allTask,data.task.taskDone) | floatNumber}} %</span></p>
         <!--  <p class="has-text-centered is-size-6 th overdue-color">Task Overdue 
            <span v-if="data.task.taskOverdue == 0">0 %</span> 
            <span v-else>{{getPercentask(data.task.allTask,data.task.taskOverdue) | floatNumber}} %</span></p> -->
        </div>
      </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>
<script>
import { HTTP } from "../axios.js";

export default {
  data() {
    return {
      activeTab:0,
      widthMax: window.innerWidth,
      isDeleteStaff: false,
      staffLists: [],
      imgUrl: process.env.VUE_APP_IMAGE_URL,
      imgUrlSC: process.env.VUE_APP_IMAGE_URL_sciencePark,
      idSelect: 0,
      delStaffName: "",
      countStartUp: 0,
      searchName: null,
      searchLastName: null,
      searchTel: null,
      searchEmail: null,
      allList: [],
      isLoadingPage: true,
      currentSort: "",
      currentSortDir: "asc",
      adminData:[]
    };
  },

  async mounted() {
    this.isLoadingPage = true;
    await this.fetchData();
    this.fetchDataAdmin()
  },
  computed: {
    report(){
      return this.$store.state.report
    },
    batch() {
      return this.$store.state.batch;
    },
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
    getRule() {
      return this.$store.getters.getRule;
    },
  },
  methods: {
    getPercentask(all,amount){
      let percen = (amount*100)/all
      return percen
    },
    getPercentaskOver(done,over){
      let total = done+over
      let percen = (over*100)/total
      return percen
    },
    goToAdmin(value,view){
      let data =[{
          key:'scienceParkId',
          value:value
        },{
          key:'viewAdmin',
          value:view
        }
      ]
      //console.log('goToAdmin',data)
      data.map(item=>{
        this.$store.commit('setReportId',item)
      })
      this.$router.push('/report-admin-list')
    },
    sortBy(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;

      if (
        typeof this.staffLists === "undefined" ||
        this.staffLists === null ||
        this.staffLists.length === 0
      ) {
      } else {
        this.staffLists = this.staffLists.sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === "desc") modifier = -1;
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
      }
    },
    goToCompany(value){
      let data ={
        key:'adminId',
        value:value
      }
      this.$store.commit('setReportId',data)
      this.$router.push('/report-company-list')
    },
    resetFilter() {
      this.staffLists = this.allList;
      this.searchName = null;
      this.searchTel = null;
      this.searchEmail = null;
      this.searchLastName = null;
    },
    async fetchDataAdmin() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      let data
      if(this.getRule == 'board'){
        //console.log('1')
        data = {
          url:'/api/get/all/admin',
          scienceParkId:this.user.scienceParkId,
          underId:this.user.under
        } 
      }else{
        data = {
          url:'/api/get/all/admin/not/under',
          underId:this.user.under
        }
      }
        //console.log('send',data)
        await HTTP.post(data.url,data)
          .then(res => {
            //console.log(data.url, res);
            if (res.data.success) {
              this.adminData = res.data.obj.adminNotUnder
              let data =[]
              let checkId = []
              res.data.obj.adminNotUnder.map(value=>{
                if(data.length > 0){
                  checkId = data.filter(search =>{
                    return value.adminId == search.adminId
                  })
                }
                //console.log('checkId',checkId)
                if(checkId.length == 0){
                  let filter = res.data.obj.adminNotUnder.filter(search =>{
                    return value.adminId == search.adminId
                  })
                  //console.log('filter',filter)
                  if(filter.length > 0){
                    filter.map((admin,index) =>{
                      //console.log('admin',admin)
                      if(index == 0){
                        data.push(admin)
                      }else{
                        data[0].batchs.push(admin.batchs[0])
                        data[0].activities += admin.activities
                        data[0].allCompanies += admin.allCompanies
                        let objStatus = Object.keys(data[0].status)
                        objStatus.map(obj =>{
                          data[0].status[obj] += admin.status[obj]
                        })
                        let objTask = Object.keys(data[0].task)
                        objTask.map(obj =>{
                          data[0].task[obj] += admin.task[obj]
                        })
                      }
                      //console.log('data1',data)     
                    })
                  }
                }
                 checkId = []
                }) 
                //console.log('data2',data) 
                this.adminData =   data

                setTimeout(() => {
                    this.isLoadingPage = false;
                }, 5000);
              
            } else {
              this.adminData = []
              setTimeout(() => {
                  this.isLoadingPage = false;
              }, 500);
            }
          })
          .catch(e => {
            // this.isLoadingPage = false;
            console.log(data.url+'/error', e);
            alert("เครือขายไม่เสถียร กรุณาลองใหม่ 1");
          });
    },
    async fetchData() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;

      await HTTP.post(`/api/exclusive/board/get/sumary/science/park`,{underId:this.user.under})
        .then(res => {
         // console.log('/api/exclusive/board/get/sumary/science/park', res);
          if (res.data.success) {
           let staff = res.data.obj.sort((a, b) => {
              const modifier = 1;
              if (a.departmentId < b.departmentId) return -1 * modifier;
              if (a.departmentId > b.departmentId) return 1 * modifier;
              return 0;
            });
            this.staffLists = res.data.obj;
            this.allList = res.data.obj;
          } else {
            this.staffLists = [];
            this.allList = [];
          }
        })
        .catch(e => {
          console.log("/api/exclusive/board/get/sumary/science/park", e);
          alert("เครือขายไม่เสถียร กรุณาลองใหม่ 3");
        });
    },
    dateFomat(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "";
      } else {
        res = this.$moment(date).format("DD MMMM Y h:mm a");
      }
      return res;
    }
  }
};
</script>
/* eslint-disable */
<style scoped>
@media screen and (max-width: 1280px) {
  .figureless {
    margin-left: 0.2rem !important;
  }
}
@media screen and (min-width: 1280px) {
  .figureless {
    margin-left: 1.5rem !important;
  }
}
.color-inprocess{
  color: #00db4d;
}
.color-succeed{
  color: #00a79d;
}

.color-deactive{
  color: #b5b5b5;
}
.textDetailStaffUpList {
  font-size: 0.8rem;
}
#textNameBox {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}


.boxIconEllipsis {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}
.boxIconTrash {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}
svg:not(:root).svg-inline--fa {
  overflow: visible;
  margin: 0;
}
</style>
